// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-gray[data-v-3fd919e2] {\n  color: #727272;\n}\n.boder[data-v-3fd919e2] {\n  border-right: 1px #b5c3bc solid;\n}\n.pointer[data-v-3fd919e2] {\n  cursor: pointer;\n}\n.panel-content[data-v-3fd919e2] {\n  padding: 24px;\n  background: #f7f7f7;\n  border-radius: 4px;\n}\n.text[data-v-3fd919e2] {\n  margin-bottom: 5px;\n  font-family: Lato;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16.8px;\n  letter-spacing: -0.005em;\n  text-align: left;\n}", ""]);
// Exports
module.exports = exports;
